/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CommentThreadNotificationAction } from './CommentThreadNotificationAction';
import {
    CommentThreadNotificationActionFromJSON,
    CommentThreadNotificationActionFromJSONTyped,
    CommentThreadNotificationActionToJSON,
} from './CommentThreadNotificationAction';

/**
 * 
 * @export
 * @interface CommentThreadNotification
 */
export interface CommentThreadNotification {
    /**
     * 
     * @type {string}
     * @memberof CommentThreadNotification
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof CommentThreadNotification
     */
    groupId: string;
    /**
     * 
     * @type {boolean}
     * @memberof CommentThreadNotification
     */
    isSeen: boolean;
    /**
     * 
     * @type {number}
     * @memberof CommentThreadNotification
     */
    seenAt?: number;
    /**
     * 
     * @type {Array<CommentThreadNotificationAction>}
     * @memberof CommentThreadNotification
     */
    actions: Array<CommentThreadNotificationAction>;
}

/**
 * Check if a given object implements the CommentThreadNotification interface.
 */
export function instanceOfCommentThreadNotification(value: object): value is CommentThreadNotification {
    let isInstance = true;
    isInstance = isInstance && "type" in value && value["type"] !== undefined;
    isInstance = isInstance && "groupId" in value && value["groupId"] !== undefined;
    isInstance = isInstance && "isSeen" in value && value["isSeen"] !== undefined;
    isInstance = isInstance && "actions" in value && value["actions"] !== undefined;

    return isInstance;
}

export function CommentThreadNotificationFromJSON(json: any): CommentThreadNotification {
    return CommentThreadNotificationFromJSONTyped(json, false);
}

export function CommentThreadNotificationFromJSONTyped(json: any, ignoreDiscriminator: boolean): CommentThreadNotification {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': json['type'],
        'groupId': json['group_id'],
        'isSeen': json['is_seen'],
        'seenAt': !exists(json, 'seen_at') ? undefined : json['seen_at'],
        'actions': ((json['actions'] as Array<any>).map(CommentThreadNotificationActionFromJSON)),
    };
}

export function CommentThreadNotificationToJSON(value?: CommentThreadNotification | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'group_id': value.groupId,
        'is_seen': value.isSeen,
        'seen_at': value.seenAt,
        'actions': ((value.actions as Array<any>).map(CommentThreadNotificationActionToJSON)),
    };
}

